import { GetSlotsResponse, CreateBookingResponse } from '@/types/scheduling';

/**
 * Handles errors for slot fetching
 */
export function handleSlotsError(
  error: unknown,
  date: Date,
  durationMinutes: number
): GetSlotsResponse {
  console.error('%c❌ CAL.COM - EXCEPTION', 'color: #ef4444; font-weight: bold; font-size: 12px');
  console.error('Erreur:', error);
  
  const errorMessage = error instanceof Error ? error.message : 'Erreur inconnue lors de la récupération des créneaux';
  
  return {
    success: false,
    error: errorMessage,
    slots: [],
  };
}

/**
 * Handles errors for bookings
 */
export function handleBookingError(
  error: unknown,
  context: string = 'réservation'
): CreateBookingResponse {
  console.error(`%c❌ CAL.COM - EXCEPTION ${context.toUpperCase()}`, 'color: #ef4444; font-weight: bold; font-size: 12px');
  console.error('Erreur:', error);
  
  return {
    success: false,
    error: error instanceof Error ? error.message : 'Erreur inconnue',
  };
}

/**
 * Handles cancellation error with sync logic
 */
export async function handleCancellationError(
  error: unknown,
  bookingUid: string,
  updateBookingByUid: (uid: string, updates: { status: string }) => Promise<any>
): Promise<{ success: false; error: string }> {
  const errorMessage = error instanceof Error ? error.message : String(error);
  
  if (errorMessage.includes('cancelled already') || errorMessage.includes('has been cancelled')) {
    console.log('%c🔄 SYNCHRONISATION - Booking déjà annulé dans Cal.com, mise à jour Supabase', 'color: #f59e0b; font-weight: bold');
    await updateBookingByUid(bookingUid, { status: 'cancelled' });
    return {
      success: false,
      error: 'Ce rendez-vous a déjà été annulé',
    };
  }
  
  return {
    success: false,
    error: errorMessage,
  };
}

